import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseWrongInventoryEffectForManualCalculation extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.purchase.validation.wrong-inventory-effect-for-manual-calculation');
    }
}
